import { render } from "./ui-dialog.vue?vue&type=template&id=9dd8d4f6&ts=true"
import script from "./ui-dialog.vue?vue&type=script&lang=ts"
export * from "./ui-dialog.vue?vue&type=script&lang=ts"

import "./ui-dialog.vue?vue&type=style&index=0&id=9dd8d4f6&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__